import React from 'react';
import styled from 'styled-components';

import Layout from '../components/Layout';
import Container from '../components/Container';
import NewsletterForm from '../components/NewsletterForm';

const Header = styled.h2`
  font-family: Roboto, sans-serif;
  font-weight: 400;
  margin-top: 3rem;
`;
const Paragraph = styled.p`
  font-family: Roboto, sans-serif;
`;

const AboutMe = () => (
  <Layout>
    <Container wide>
      <Header>
        Możesz się ze mną skontaktować wysyłając maila pod adres{' '}
        <a target="_blank" href="mailto:slawkolodziej+blog@gmail.com">
          slawkolodziej+blog@gmail.com
        </a>
      </Header>
      <Paragraph>
        Zachęcam również do zapisania się do newslettera, aby nie przegapić
        nowych postów.
      </Paragraph>
      <NewsletterForm />
    </Container>
  </Layout>
);

export default AboutMe;
